module.exports = __webpack_public_path__ + "static/media/graph-icon.790899ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/graph-icon.svg
// module id = 500
// module chunks = 0